module.exports = __webpack_public_path__ + "static/media/hotel-villa-antonio-orebic-front-photo.86e605b2.jpg";